<script>
    import Viz8 from './Viz8.svelte';
    export let datapoint = {};
    export let cars = [];
    export let y_offset = 0;

    // $: console.log(datapoint['cars'] + " -- " + y_offset + " -- " + translation)
    const isInList = function(car) {
        if ( datapoint["cars"].includes(car) ) {
            return true
        }
        return false
    }

    $: translation = "translate(10, " + (10+y_offset*15) + ")"
</script>

<style>
    circle {
        fill: white;
        stroke: black;
    }
    circle.selected {
        fill: black;
    }
    line {
        stroke: black;
        stroke-width: 0.5;
    }
    text {
        font-size: small;
    }
</style>

<g transform={translation}>
    <line x1=0 x2=570 y1=0 y2=0 />
    {#each cars as car, i}
        <circle class:selected={isInList(car)}
                cx={i*15} cy=0 r=5 />
    {/each}
    <text x=580 y=5>{datapoint.num_overlaps}</text>
    <g transform="translate(600,0)">
        <Viz8 details={datapoint["details"]} />
    </g>
</g>
